<script>
    import {store} from "./Utils/stores";
    import {progressStore} from "./stores/authStore";
    import {update_video} from "./Utils/RouterUtils.svelte";
    import DifficultyBadge from "./DifficultyBadge.svelte";
    import {previewUrlForVideo} from "./services/imageService";

    export let video = null;
    export let isPlaylist;
    import {fade} from "svelte/transition";
    import Debug from "./Utils/Debug.svelte";
    import CardBody from "./CardBody.svelte";
    import CardTitle from "./CardTitle.svelte";
    import CardDescription from "./CardDescription.svelte";
    import CardImage from "./CardImage.svelte";
</script>
{#if video}
    {#if $store.search}
        <div
            class="vec-mb-5 vec-flex vec-flex-col vec-space-y-3 vec-rounded-3xl vec-rounded-bl-none vec-p-5 hover:vec-cursor-pointer hover:vec-bg-gradient-to-t hover:vec-from-lighterGrey hover:vec-to-white/0"
                in:fade={{ delay: 0, duration: 200 }}
                on:click
        >
            <CardImage
                src={previewUrlForVideo(video)}
                alt={video.videoTitle}
            />
            <CardBody>
                <DifficultyBadge difficulty={video.difficulty}/>
                <CardTitle>{video.videoTitle}</CardTitle>
                <CardDescription>{video.shortDescription}</CardDescription>
            </CardBody>
        </div>
    {:else}
        <div
            class="vec-mb-5 vec-flex vec-flex-col vec-space-y-3 vec-rounded-3xl vec-rounded-bl-none vec-p-5 hover:vec-cursor-pointer hover:vec-bg-gradient-to-t hover:vec-from-lighterGrey hover:vec-to-white/0"
                in:fade={{ delay: 0, duration: 200 }}
                on:click={update_video(video.slug.current)}
        >
            {#if $progressStore.watched[video.slug.current]}
                <CardImage
                    src={previewUrlForVideo(video)}
                    alt={video.videoTitle}
                    isPlaylist={isPlaylist}
                    watched=true
                />
            {:else}
                <CardImage
                    src={previewUrlForVideo(video)}
                    alt={video.videoTitle}
                    isPlaylist={isPlaylist}
                />
            {/if}
            <CardBody>
                <DifficultyBadge difficulty={video.difficulty}/>
                <CardTitle>{video.videoTitle}</CardTitle>
                <CardDescription>{video.shortDescription}</CardDescription>
            </CardBody>
        </div>
    {/if}
{/if}
